<template>
  <div
    style="background-color: inherit; box-shadow: none;"
    class="d-flex align-start mt-3"
    width="100%"
    height="50px"
    v-if="src != null"
  >
    <v-card-actions v-if="cancelEnable" class="mt-2">
      <v-spacer></v-spacer>
      <v-icon @click="resetInput">mdi-close-circle</v-icon>
    </v-card-actions>

    <v-expand-transition mode="out-in">
      <audio style="height: 50px;width: 300px;" controls>
        <source :src="src" type="audio/mpeg" />
      </audio>
    </v-expand-transition>
  </div>
  <div
    class="d-flex  justify-center  "
    width="80%"
    height="50px"
    @click="dialog = true"
    style="background-color: inherit;"
    v-else
  >
    <v-progress-circular
      v-if="loader"
      indeterminate
      color="primary"
      class="ma-auto mt-5"
    ></v-progress-circular>
    <div v-else class="text-center  ma-auto mt-5">
      <v-icon size="40">mdi-volume-off</v-icon>
    </div>
    <add-popup
      @fileChoosen="setsrc($event)"
      @fileChoosenId="setSrcWithId($event)"
      @closePopup="dialog = false"
      :status="dialog"
      :reset="src"
      :accept="'audio/*'"
      :enablePlugin="true"
    ></add-popup>
  </div>
</template>
<script>
import addPopup from "@/components/mycomponent/base/addPopup.vue";
import { File } from "@/store/file-system/file";
import { State } from "@/store/state";
export default {
  props: {
    data: {},
    fileServer: {},
    cancelEnable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    addPopup,
  },
  data() {
    return {
      File,
      State,
      src: null,
      dialog: false,
      myState: null,
    };
  },
  methods: {
    async setSrcWithId(id) {
      this.myState = new State();
      await File.show(this.myState, id, this.fileServer);
      const blob = new Blob([this.myState.value], {});
      const imgUrl = URL.createObjectURL(blob);
      this.src = imgUrl;
      this.$emit("fileIdLoaded", id);
    },
    setsrc(file) {
      this.dialog = false;
      this.src = file;
      this.$emit("fileLoaded", file);
    },
    resetInput() {
      this.src = null;
      this.$emit("cancelFile");
    },
  },
  computed: {
    srcAudio() {
      let data = URL.createObjectURL(this.src);
      return data;
    },
    loader() {
      if (this.data) {
        return this.myState.loading;
      }
      return false;
    },
  },
  created() {
    if (this.data) {
      this.setSrcWithId(this.data);
    }
  },
};
</script>
<style lang="scss" scoped>
.video {
  width: 100% !important;
  height: 100% !important;
  margin-bottom: 50px;
}
</style>
